import { Injectable } from '@angular/core';
import { RaintreeResponse } from '../interfaces/raintree-response';
import { ApiService } from '../../common/api.service';
import { Observable } from 'rxjs';
import { ROUTES } from '../../server-route';
import { GlobalResponseData, ReportStatus } from '../interfaces/global-respo';
import { SerialStatusResponse } from '../interfaces/keyword-search';

@Injectable({
  providedIn: 'root',
})
export class MasterSearchTransmissionService extends ApiService {
  public fetchGlobalSearchRecords(
    searchName: string,
    pageNo?: number,
    pageSize?: number
  ): Observable<GlobalResponseData> {
    return this.get<GlobalResponseData>(
      this.replacePathInfo(ROUTES.GLOBAL_SEARCH, {
        searchName: searchName,
        pageNo,
        pageSize,
      })
    );
  }

  public fetchNameSearchRecords(
    nameSearchObj: any
  ): Observable<GlobalResponseData> {
    return this.post<GlobalResponseData>(ROUTES.NAME_SEARCH, {
      body: nameSearchObj,
    });
  }

  public fetchReportStatuses(): Observable<ReportStatus> {
    return this.get<ReportStatus>(ROUTES.REPORT_STATUS);
  }
  public fetchLastRefreshDate(): Observable<any> {
    return this.get<any>(ROUTES.LAST_REFRESH_DATE);
  }

  public getSlDetails(
    slNo: any,
    payLoad: any
  ): Observable<SerialStatusResponse> {
    return this.get<SerialStatusResponse>(
      this.replacePathInfo(ROUTES.GLOBAL_SEARCH_SL_DETAILS, {
        memKey: slNo,
      }),
      {
        params: payLoad,
      }
    );
  }
}
